module.exports = __webpack_public_path__ + "img/icon-toast.24f06946.svg";